module.exports = __webpack_public_path__ + "static/FAQ-welcome2-4b558711256ddf0ba7d0602c4bb23391.jpg";